import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { xmlns: "http://www.w3.org/2000/svg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("pattern", {
    id: "a",
    width: "247",
    height: "180",
    patternTransform: "scale(.8)",
    patternUnits: "userSpaceOnUse"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "100%",
      height: "100%",
      fill: "transparent"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "transparent",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      d: "M0 58.058v-.002zm0 0c3.177 31.478 25.958 62.607 51.653 51.358 4.006 27.75 42.259 24.96 51.813 4.427 5.538 24.831 52.868 15.035 53.72-11.126 57.734 7.58 48.224-92.125 0-78.513-3.762-32.249-57.83-30.83-63.574-4.291C72.106 9.737 50.107 33.47 57.486 53.046c-12.16-4.035-17.996 2.99-22.976 8.985-1.56 1.877-3.035 3.653-4.594 4.957-6.54 5.467-20.009 2.909-29.916-8.93ZM107.546 8.173c5.232-2.959 12.03-4.528 18.752-4.364 6.723.164 13.295 2.014 18.223 5.467s8.34 8.324 9.16 15.346c.255 2.152 2.655 3.776 4.748 3.213 10.861-3.066 18.714.059 24.697 6.522 5.984 6.464 9.709 16.66 10.263 27.048s-2.055 20.837-7.769 27.959c-5.713 7.121-14.334 11.348-27.718 9.59-30.179-7.9-9.718-40.858 6.225-30.515l.878-3.943c-20.596-11.795-42.682 24.339-11.371 38.055-.176 5.407-2.667 9.95-6.714 13.62s-9.641 6.299-15.346 7.481c-5.704 1.181-11.507.876-15.825-.911-4.318-1.788-7.221-4.698-8.344-9.736-.339-1.539-1.73-2.786-3.297-2.954s-3.191.755-3.849 2.187c-3.988 8.571-14.548 13.892-24.458 13.716-4.955-.089-9.645-1.535-13.188-4.268-3.543-2.734-5.53-6.837-7.002-12.805-5.408-21.91 22.112-30.27 25.208-8.768l4.38-.297c-3.104-27.867-38.35-16.833-34.864 6.14-11.295 4.944-21.312.818-29.925-8.728-6.579-7.293-11.755-17.794-14.53-29.013 3.138 2.097 6.38 3.611 9.59 4.46 6.29 1.661 12.646.96 17.12-2.782 2.156-1.802 3.932-3.953 5.631-6.012 1.533-1.857 3.003-3.638 4.632-5.018 3.436-2.91 6.726-4.51 13.668-2.206 1.352.454 2.95.062 3.938-.967s1.316-2.64.81-3.972C55.12 35.413 73.656 14.553 92.2 23.328c-10.104 47.22 54.502 38.554 39.08 2.572l-4.697 2.56c12.568 27.626-41.382 36.48-29.06-7.722 1.177-5.437 4.792-9.606 10.023-12.565Z",
      "clip-rule": "evenodd"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "800%",
  height: "800%",
  fill: "url(#a)"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }